import React from "react";
import ReactSVG from "react-svg";
import { Margin, Title, Text } from "~/components/elements";
import Email from "~/assets/img/icon/email.svg";
import { useSelector } from "react-redux";

export default function UpdateEmailSent({ mobile, closeModal }) {
  const newEmail = useSelector(
    (state) => state?.account?.updateEmail?.user?.email
  );
  return (
    <>
      <Margin mb={2}>
        <ReactSVG wrapper="div" src={Email} />
      </Margin>
      <Margin mb={2}>
        <Title level="5" as="3">
          Solicitud de cambio de correo enviada con éxito
        </Title>
      </Margin>
      <Margin mb={4}>
        <Text primary level="2">
          Se ha enviado un correo electrónico de confirmación a {newEmail}
        </Text>
      </Margin>
      <Margin mb={4}>
        <Text primary level="2">
          Ingresa tu nuevo correo electrónico y has clic en "CONFIRMAR" para
          confirmar la actualización. La nueva dirección de correo electrónico
          sólo se cambiará en tu cuenta después de la confirmación.
        </Text>
      </Margin>
    </>
  );
}
